<h2 mat-dialog-title id="dialog-title">{{ data.header }}</h2>
<mat-divider></mat-divider>
<mat-dialog-content aria-labelledby="dialog-title">
    <div *ngIf="data.param == 'delete'">
        <mat-label>
            Do you want to delete this record?
        </mat-label>
    </div>
    <form [formGroup]="userForm" *ngIf="data.param != 'delete'">
        <table>
            <tr>
                <td>
                    <label for="firstName" style="width: 120px;">
                        First Name:<sup class="star" style="color:#ea4848">*</sup>
                    </label>
                </td>
                <td style="padding-left: 10px;">
                    <input id="firstName" type="text" [readonly]="data.param === 'view'" class="form-control control-width" [ngClass]="{'readonly-field': data.param === 'view'}" formControlName="firstName">
                    <div *ngIf="userForm.get('firstName')?.touched && userForm?.get('firstName')?.errors?.['required']" style="color:red">
                        Please enter first name
                    </div>
                </td>
            </tr><br>
            <tr>
                <td>
                    <label for="middleName" style="width: 120px;">
                        Middle Name:
                    </label>
                </td>
                <td style="padding-left: 10px;">
                    <input id="middleName" type="text" [readonly]="data.param === 'view'" class="form-control control-width" [ngClass]="{'readonly-field': data.param === 'view'}" formControlName="middleName">
                </td>
            </tr><br>
            <tr>
                <td>
                    <label for="lastName" style="width: 120px;">
                        Last Name:<sup class="star" style="color:#ea4848">*</sup>
                    </label>
                </td>
                <td style="padding-left: 10px;">
                    <input id="lastName" type="text" [readonly]="data.param === 'view'" class="form-control control-width" [ngClass]="{'readonly-field': data.param === 'view'}" formControlName="lastName">
                    <div *ngIf="userForm.get('lastName')?.touched && userForm?.get('lastName')?.errors?.['required']" style="color:red">
                        Please enter last name
                    </div>
                </td>
            </tr><br>
            <tr>
                <td>
                    <label for="email">
                        Email:<sup class="star" style="color:#ea4848">*</sup>
                    </label>
                </td>
                <td style="padding-left: 10px;">
                    <input 
                        type="email"
                        [readonly]="data.param === 'view'"
                        id="email" 
                        name="email" 
                        class="form-control control-width"
                        [ngClass]="{'readonly-field': data.param === 'view'}"
                        formControlName="email"
                    >
                    <div *ngIf="userForm.get('email')?.touched && userForm?.get('email')?.errors?.['required']" style="color:red">
                        Please enter an email address.
                    </div>
                    <div *ngIf="userForm.get('email')?.touched && userForm?.get('email')?.errors?.['pattern']" style="color:red">
                        Please enter a valid email address.
                    </div>
                </td>
            </tr><br>
            <tr>
                <td>
                    <label for="role" style="width: 120px;">
                        Role<sup class="star" style="color:#ea4848">*</sup>
                    </label>
                </td>
                <td style="padding-left: 10px;">
                    <select id="role" class="form-select control-width" 
                        aria-label="Role" formControlName="role"
                        [ngClass]="{'readonly-field': data.param === 'view'}">
                        <option [ngValue]="'ADMIN'" [disabled]="data.param === 'view'">{{ 'Admin' }}</option>
                        <option [ngValue]="'CASE_MANAGER'" [disabled]="data.param === 'view'">{{ 'Case Manager' }}</option>
                    </select>
                    <div *ngIf="userForm.get('role')?.touched && userForm?.get('role')?.errors?.['required']" style="color:red">
                        Please select a role
                    </div>
                </td>
            </tr>
        </table>
    </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
    <button 
    mat-button 
    mat-dialog-close 
    cdkFocusInitial
    *ngIf="data.param != 'view'"
    class="btn btn-primary-outline modal-btn-1"
    [disabled]="((!userForm.valid) && (data.param != 'delete'))"
    (click)="onSubmit()"
    >
        {{ data.param == 'edit' ? 'Save' : data.param == 'delete' ? 'Yes' : 'Submit' }}
    </button>
    <button 
    mat-button
    mat-dialog-close
    class="btn modal-btn"
    >
        {{ data.param == 'delete' ? 'No' :'Cancel' }}
    </button>
</mat-dialog-actions>
